import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { BrowserRouter, HashRouter, Route, Switch, Redirect, Link } from 'react-router-dom';

// Containers
import Home from '../containers/Home';
import Welcome from '../containers/Welcome';
import Page404 from '../containers/Page404';
import Page500 from '../containers/Page500';
import AccessDenied from '../containers/AccessDenied';

// Components
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Sidebar from '../components/Sidebar/Sidebar';
import Overlay from '../components/Sidebar/Overlay';
import ActivityIndicator from '../components/ActivityIndicator/ActivityIndicator';
import SplashScreen from '../components/SplashScreen/SplashScreen';
import Login from '../components/Login/Login';
import { config } from '../constants/domainConfig';
import CookieConsent from "react-cookie-consent";
import PrivateRoute from './../PrivateRoute'
// Helpers
import { console_log } from '../utils/helper';
import { detect } from 'detect-browser';
import TwoStepLogin from '../components/Login/TwoStepLogin';
import { isGamiclub } from "../constants/isGamiclub";
import { isOnlyBeemobi } from '../constants/isOnlyBeemobi';
import { isAppspool } from '../constants/isAppspool';
import { isTheGamingClubs } from '../constants/isTheGamingClubs';
import { isGamezClan } from '../constants/isGamezClan';
import { isOnlyMobbfun } from '../constants/isOnlyMobbfun';
import { isGameflares, isGamiway } from '../constants/productCondition';
import { getDomainTheme } from '../utils/domainTheme';


const browser = detect();

const frenchDomain = (config.lang == 'fr' && config.subDomain != 'ch') ? true : false;
const swedishDomain = (config.lang == 'sv') ? true : false;
const belgiumDomain = (config.subDomain == 'be') ? true : false;
const norwayDomain = (config.lang == 'no') ? true : false;
const vietnamDomain = (config.lang == 'vi') ? true : false;
const arabicDomain = (config.lang == 'ar') ? true : false;
const turkeyDomain = (config.lang == 'tr') ? true : false;
const spanishDomain = (config.lang == 'es') ? true : false;
const itelianDomain = (config.subDomain == 'it') ? true : false;
const ghanaDomain = (config.subDomain == 'gh') ? true : false;
const rsDomain = (config.subDomain == 'rs') ? true : false;
const grDomain = (config.subDomain == 'gr') ? true : false;
const roDomain = (config.subDomain == 'ro') ? true : false;
const czDomain = (config.subDomain == 'cz') ? true : false;
const peDomain = (config.subDomain === 'pe' && !isGamiclub) ? true : false;
const myDomain = (config.subDomain === 'my' && isGamiclub) ? true : false;

const Aux = (props) => {
    return props.children;
}

class App extends Component {
    constructor(props){
        super(props);
        this.state = {
            showA2SHPopUp: true,
            showMaxisLogin: false // <-- Add this
        };        
        this.renderPromptAlertBox = this.renderPromptAlertBox.bind(this);
        this.renderNotificationAlertBox = this.renderNotificationAlertBox.bind(this);
        this.renderMaxisLoginBox = this.renderMaxisLoginBox.bind(this);
        this.onA2HSClick = this.onA2HSClick.bind(this);
        this.handleBodyClass = this.handleBodyClass.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    }
    toggleMaxisLoginBox = (show) => {
        this.setState({ showMaxisLogin: show });
        this.handleBodyClass(show);
    };    
    handleBodyClass(isOpen) {
        const body = document.querySelector('body');
        if (isOpen) {
          body.classList.add('modal-open'); // Background scrolling aur clicks disable
        } else {
          body.classList.remove('modal-open'); // Background scrolling aur clicks re-enable
        }
    }
    onChangeEmail(e) {
        this.setState({email: e.target.value});
    }
    onKeyUp(e) {
        if (e.keyCode == 13) {
            this.onSubmit(e);
        }
    }
    onSubmit(e) {
        e.preventDefault();
        const email = this.state.email;

        if (!email) {
            this.setState({ emailError: "Please enter email address" });
        }
        else 
        {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                this.setState({ emailError: "Invalid email address" });
            }
            else{
                sessionStorage.setItem("maxis_email", email);
                this.toggleMaxisLoginBox(false);
            }
        }
    }
    onA2HSClick(){
        const promptEvent = window.deferredPrompt;
        if(!promptEvent) return;
        promptEvent.prompt();
        window.deferredPrompt = undefined;
    }
    renderPromptAlertBox(){
        if(!this.state.showA2SHPopUp) return null;
        if(window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) return null;
        return(
            <div className='pwa-prompt'>
                <button className='close-icon' onClick={() => {
                    this.setState({ showA2SHPopUp: false })
                }}>
                    <i className='fa fa-times' />
                </button>
                <div className='pwa-heading'>
                Para añadir Gamelords a la pantalla de inicio, abre las opciones y pulsa Añadir a pantalla inicio                </div>
                {browser.name === "chrome" 
                ? <div className='pwa-buttons'>
                    <button onClick={() => {
                        const promptEvent = window.deferredPrompt;
                        if(!promptEvent) return;
                         promptEvent.prompt();
                         window.deferredPrompt = undefined;
                         return;
                    }}>
                        Añadir
                    </button>
                </div> 
                : null}
            </div>
        )
    }
    renderNotificationAlertBox(){
        if(!this.state.showA2SHPopUp) return null;
        this.handleBodyClass(true);
        if(window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) return null;
        return(
            <div className='pwa-prompt pwa-notification'>
                <button className="close-icon" onClick={() => {
                    this.setState({ showA2SHPopUp: false }, () => {
                        this.handleBodyClass(false); // Popup close hone par background enable
                    });
                }}>
                    <i className='fa fa-times' />
                </button>
                <div className='pwa-heading'>
                    <h3>Need help? Our support team is ready to assist you.</h3>
                    <p><b>Support Line:</b> <a href="tel:1800819748">1800819748</a></p>
                    <p><b>Email:</b> <a href="mailto:mycs@content-clubs.com">mycs@content-clubs.com</a></p>
                    <p><b>Subscription:</b> <a href="https://checksubscription.com/?c=my">https://checksubscription.com/?c=my</a></p>
                    { config.subDomain !== 'my' && !isGamiclub  &&
                        <div className='pwa-buttons'>
                        <a href="https://api.whatsapp.com/send/?phone=601111673277&text&type=phone_number&app_absent=0" className="conatct-us-btn" target="_blank"><button>
                            <svg viewBox="0 0 20 20" className="message-us-button_logo" width="20px" height="20px">
                                <path fillRule="evenodd" d="M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C8.21764336,20 6.50261894,19.5321866 4.99604377,18.6597493 L1.09644722,19.9573724 C0.445123153,20.1741059 -0.17423773,19.5545345 0.0427170752,18.9032841 L1.34118515,15.0055699 C0.468152857,13.4986162 4.48352336e-12,11.7830015 4.48352336e-12,10 C4.48352336e-12,4.4771525 4.4771525,0 10,0 Z M10,1.66666667 C5.39762709,1.66666667 1.66666667,5.39762709 1.66666667,10 C1.66666667,11.6017128 2.11850111,13.1345631 2.95730951,14.4569627 C3.09146627,14.6684637 3.1233805,14.929089 3.04422002,15.1667113 L2.15025713,17.8501903 L4.83522181,16.956746 C5.07271735,16.8777174 5.33315744,16.9096255 5.54455056,17.0436501 C6.86661689,17.8818489 8.39890565,18.3333333 10,18.3333333 C14.6023729,18.3333333 18.3333333,14.6023729 18.3333333,10 C18.3333333,5.39762709 14.6023729,1.66666667 10,1.66666667 Z M6.55072391,5.00454308 C6.71472826,5.00454308 6.87873262,5.00454308 7.02048512,5.01164697 C7.1713032,5.02141482 7.37404224,4.94859994 7.57430887,5.46540794 C7.78034448,5.99642371 8.27235754,7.30442746 8.33334408,7.43584942 C8.39515477,7.56727138 8.43636189,7.72355696 8.35559593,7.90026623 C8.27318168,8.07786348 8.23032628,8.18886176 8.10835319,8.34070741 C7.98555596,8.49699298 7.85039659,8.68791003 7.73831322,8.80512421 C7.61551599,8.93832215 7.48694976,9.08039995 7.63199884,9.34679582 C7.77375134,9.61052774 8.26906097,10.4807543 9.00007535,11.1822634 C9.94042191,12.0871214 10.7324228,12.368613 10.9796656,12.500035 C11.2244359,12.6323449 11.369485,12.6074813 11.5112375,12.434324 C11.6554624,12.2576147 12.1252236,11.66 12.2900521,11.3936041 C12.4540565,11.1298722 12.618885,11.1716076 12.8438758,11.2621822 C13.0688667,11.3492048 14.279532,11.9903309 14.5243024,12.1217528 C14.7723692,12.2567268 14.9363736,12.3233257 14.9973601,12.434324 C15.0591708,12.5453223 15.0591708,13.0763381 14.8556076,13.6934885 C14.649572,14.3141909 13.6680183,14.8798381 13.1949605,14.955317 C12.769703,15.0219159 12.2323621,15.0494435 11.6431003,14.8487586 C11.1671235,14.6897973 10.6994329,14.5033465 10.2420581,14.2902153 C7.77375134,13.1411611 6.16090452,10.4638825 6.03893144,10.2907252 C5.91531006,10.113128 5.03347762,8.8512995 5.03347762,7.5468477 C5.03347762,6.24328389 5.66806732,5.60126983 5.89305822,5.33753792 C6.11887326,5.07025406 6.38589542,5.00454308 6.55072391,5.00454308 Z" fill="#25D366"></path>
                            </svg>                          
                            Whatsapp
                        </button></a>
                    </div>
                    }
                </div>
            </div>
        )
    }
    renderMaxisLoginBox() {
        if (!this.state.showMaxisLogin) return null;
        return (
            <div className='pwa-prompt pwa-notification'>
                <button className="close-icon" onClick={() => this.toggleMaxisLoginBox(false)}>
                    <i className='fa fa-times' />
                </button>
                <div className='pwa-heading'>
                    <h3>You want to Signup / Login?</h3>
                    <input autoFocus type="email" name="email" value={this.state.email} className="LoginRoute-number" placeholder="Enter E-mail Address" onKeyUp={this.onKeyUp} onChange={this.onChangeEmail} />
                    <div className='pwa-buttons'>
                        <button type="submit" onClick={this.onSubmit} style={{backgroundColor: 'green'}} className="LoginRoute-button">
                            Login
                            <i className="icon-back"></i>
                        </button>
                    </div>    
                    {this.state.emailError ? <span className="error-message">{this.state.emailError}</span> : null}                                
                </div>
            </div>
        );
    }
    render() {
        const {productName} = getDomainTheme()

        let routes_align_center = ["/404", "/500", "/restricted", "/404/", "/500/", "/restricted/"],
            app_body_class = (routes_align_center.indexOf(this.props.location.pathname) == -1) ? "app-body flex-column" : "app-body flex-row align-items-center";
        if (browser.os === "Android OS" || browser.os === 'ios') {
            if ((browser.name === "chrome" && parseInt(browser.version) < 51)
                || (browser.name === "ie" && parseInt(browser.version) < 10)
                || (browser.name === "firefox" && parseInt(browser.version) < 52)
                || (browser.name === "safari" && parseInt(browser.version) < 7)
                || (browser.name === "edge" && parseInt(browser.version) < 10)
                || (browser.name === "opera" && parseInt(browser.version) < 16)
            ) {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', width: '100%' }}>
                        <div style={{ height: "20vh", width: "100%", flexDirection: "column", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'red' }}>
                            <h3 > {browser.name} (version: {browser.version}) unsupported</h3>
                            <h4 >Please download latest browser version. </h4>
                        </div>
                    </div>
                )
            }
        }
        if (this.props.location.pathname == "/") {
            return <Route path="/" name="Splash Screen" component={SplashScreen} />
        }
        else {
            let cookieMsg, moreInfo, privacyLink, btnText, to;
            //let productName = isGamiclub ? (isOnlyBeemobi ? 'Beemobi' : isOnlyMobbfun ? 'Mobbfun' : 'Gamiclub') : isAppspool ? 'Appspool' : isGamezClan ? 'Gamezclan' : isGameflares ? 'Gameflares' : isGamiway ? 'Gamiway' : isTheGamingClubs ? 'GamingClubs' :'Gamelord'
            if (this.props.currentLang == 'fr' && config.subDomain == 'cd') {
                cookieMsg = 'Salut! Notre site Web utilise des cookies pour vous garantir la meilleure expérience possible avec Gamelord.';
                moreInfo = 'Plus d\'informations';
                privacyLink = 'http://n.game-lords.com/cd/tnc-game-lords?offer=1&device=pc&operator=CD_ORANGE&operatorSubmitted=Y&_next=privacy_policy.html&_extracted=cb1f85f2bd874c32be224af2512f5369&';
                btnText = 'Je l\'ai!';
                to = '/';
            }
            else if (this.props.currentLang == 'fr') {
                cookieMsg = `Salut! Notre site Web utilise des cookies pour vous garantir la meilleure expérience possible avec ${productName}.`;
                moreInfo = 'Plus d\'informations';
                privacyLink = '/privacy-policy';
                btnText = 'Je l\'ai!';
                to = '/privacy-policy';
            }
            else if(this.props.currentLang == 'de'){
                cookieMsg = `Hallo! Unsere Website verwendet Cookies, um sicherzustellen, dass Sie die bestmögliche Erfahrung damit machen ${productName}.`;
                moreInfo = 'Mehr Info';
                privacyLink = '/privacy-policy';
                btnText = 'Verstanden';
                to = '/privacy-policy';
            }
            else if(this.props.currentLang == 'be'){
                cookieMsg = `Hoi! Onze website maakt gebruik van cookies om ervoor te zorgen dat u de best mogelijke ervaring met ${productName} krijgt.`;
                moreInfo = 'Meer Informatie';
                privacyLink = '/privacy-policy';
                btnText = 'Begrepen!';
                to = '/privacy-policy';
            }
            else if (this.props.currentLang == 'ar') {
                cookieMsg = 'مرحبا! يستخدم موقعنا ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة ممكنة مع غيملورد';
                moreInfo = 'مزيد من المعلومات';
                privacyLink = '/privacy-policy';
                btnText = 'قبلت';
                to = '/privacy-policy';
            }
            else if (config.subDomain === 'pt') {
                cookieMsg = `Olá! Nosso site usa cookies para garantir que você obtenha a melhor experiência possível com a ${productName}.`;
                moreInfo = 'mais informações';
                privacyLink = '/privacy-policy';
                btnText = 'Entendi!';
                to = '/privacy-policy';
            } 
            else if (config.subDomain === 'lt') {
                cookieMsg = `Sveiki! Mūsų svetainė naudoja slapukus, kad užtikrintų geriausią patirtį su ${productName}.`;
                moreInfo = 'daugiau informacijos';
                privacyLink = '/privacy-policy';
                btnText = 'Supratau!';
                to = '/privacy-policy';
            } 
            else if (ghanaDomain) {
                cookieMsg = 'Hi! Our website uses cookies to ensure you get the best possible experience with Gamelord.';
                moreInfo = 'more info';
                privacyLink = 'http://n.lordgames.info/gh/tnc-gamelords?device=pc&offer=1';
                btnText = 'Got it!';
                to = '/privacy-policy';
            }
            else if(rsDomain) {
                cookieMsg = `Ћао! Наша веб локација користи колачиће како би осигурала најбоље могуће искуство на ${productName}.`;
                moreInfo = 'више информација';
                privacyLink = '/privacy-policy';
                btnText = 'разумем';
                to = '/privacy-policy';
            }
            else if (swedishDomain) {
                cookieMsg = 'Hej! Vår webbplats använder cookies för att säkerställa att du får den bästa möjliga upplevelsen med Gamelord.';
                moreInfo = 'Mer information';
                privacyLink = 'http://n.game-lords.com/se/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html&_extracted=b46947911ad34990bc9776146fc173b9&';
                btnText = 'Jag förstår!';
                to = '/';
            }
            else if (belgiumDomain) {
                cookieMsg = 'Onze website maakt gebruik van cookies om ervoor te zorgen dat u de best mogelijke ervaring met Gamelord krijgt.';
                moreInfo = 'Meer informatie';
                privacyLink = 'http://n.game-lords.com/be/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html';
                btnText = 'Begrijp ik!';
                to = '/';

            }
            else if (norwayDomain) {
                cookieMsg = `Hei! Nettsiden vår bruker informasjonskapsler for å sikre at du får best mulig opplevelse med ${productName}.`;
                moreInfo = 'Mer info';
                privacyLink = '/privacy-policy-no';
                btnText = 'Skjønner!';
                to = '/privacy-policy-no';

            }
            else if (vietnamDomain) {
                cookieMsg = 'Xin Chào! Trang web của chúng tôi sử dụng cookie để đảm bảo bạn có được trải nghiệm tốt nhất có thể với Gamelord.';
                moreInfo = 'Đọc thêm';
                privacyLink = '/privacy-policy';
                btnText = 'Tiếp tục!';
                to = '/';

            }
            else if (turkeyDomain) {
                cookieMsg = 'Merhaba! Web sitemiz, touchnote ile mümkün olan en iyi deneyimi elde etmek için çerezleri kullanır.';
                moreInfo = 'Daha fazla bilgi';
                privacyLink = '/privacy-policy';
                btnText = 'Anladım!';
                to = '/privacy-policy';
            }
            else if (this.props.currentLang === 'it') {
                cookieMsg = `Salve! Il nostro sito Web utilizza cookie per assicurarti la migliore esperienza possibile con ${productName}.`;
                moreInfo = 'maggiori informazioni';
                privacyLink = '/privacy-policy';
                btnText = 'Ok!';
                to = '/privacy-policy';
            }
            else if (spanishDomain || config.subDomain === "es2") {
                cookieMsg = `¡Hola! Nuestro sitio web utiliza cookies para asegurarse de que obtiene la mejor experiencia posible con ${productName}.`;
                moreInfo = 'Más información';
                privacyLink = '/privacy-policy';
                btnText = '¡Entendido!';
                to = '/privacy-policy';
            }
            else if (grDomain) {
                cookieMsg = `Γεια! Ο ιστότοπός μας χρησιμοποιεί cookies για να διασφαλίσει ότι θα έχετε την καλύτερη δυνατή εμπειρία με το ${productName}.`;
                moreInfo = 'περισσότερες πληροφορίες';
                privacyLink = '/privacy-policy';
                btnText = 'Το έπιασα!';
                to = '/privacy-policy';
            }
            else if (roDomain) {
                cookieMsg = `Bună! Site-ul nostru folosește cookie-uri pentru a vă asigura că veți obține cea mai bună experiență posibilă cu ${productName}.`;
                moreInfo = 'mai multe informații';
                privacyLink = '/privacy-policy';
                btnText = 'Am înțeles!';
                to = '/privacy-policy';
            }
            else if (czDomain) {
                cookieMsg = `Dobrý den! Naše webové stránky používají soubory cookie, abychom vám zajistili co nejlepší zkušenost s ${productName}.`;
                moreInfo = 'více informací';
                privacyLink = '/privacy-policy';
                btnText = 'Jasné!';
                to = '/privacy-policy';
            }
            else if (config.subDomain ==='si') {
                cookieMsg = `Živjo! Naša spletna stran uporablja piškotke, da zagotovi najboljšo možno izkušnjo ${productName}`;
                moreInfo = 'více informací';
                privacyLink = '/privacy-policy';
                btnText = 'Jasné!';
                to = '/privacy-policy';
            }
            else if(config.subDomain === 'bg') {
                cookieMsg = `Здравейте! Нашият уебсайт използва бисквитки, за да гарантира, че ще получите възможно най-доброто преживяване с ${productName}.`;
                moreInfo = 'повече информация';
                privacyLink = '/privacy-policy';
                btnText = 'Разбрах!';
                to = '/privacy-policy';
            }
            else {
                cookieMsg = `Hi! Our website uses cookies to ensure you get the best possible experience with ${productName}.`;
                moreInfo = 'more info';
                privacyLink = '/privacy-policy';
                btnText = 'Got it!';
                to = '/privacy-policy';
            }

            let cookieStyle = { background: "#2B373B", direction: 'ltr'};
            if (this.props.currentLang == 'ar') {
                cookieStyle.direction = 'rtl';
            } else {
                cookieStyle.direction = 'ltr';
            }
            const host = window.location.hostname
            const isChatbotDomain = config.country === 'ae' && (isGamiclub || host.includes('game-lords'))
            
            return (
                <div className={`app ${isGameflares ? 'gameflares-body-bg':''}`} style={vietnamDomain ? { fontFamily: "Arial, sans-serif" } : {}}>
                    {(isGamiclub && config.subDomain === 'sn') || (isGamiclub && config.subDomain === 'my') || window.location.hostname.includes('vplay') ? null : <CookieConsent
                            location="bottom"
                            buttonText={btnText}
                            cookieName="MobiotvCookie"
                            style={cookieStyle}
                        buttonStyle={{ backgroundColor: "white", fontSize: "13px", margin: '5px', marginRight: `${isChatbotDomain ? '10%' : '5px'}` }}
                            contentStyle = {{flex: 'none'}}
                          
                        >
                            {cookieMsg}{" "}
                            {(frenchDomain || swedishDomain || vietnamDomain || ghanaDomain)?<Link onClick={(e) => window.location = privacyLink} to={to}>
                            <p style={{ color: "skyblue" }}>{moreInfo}</p>
                        </Link>
                            : <Link to={to}>
                                <p style={{ color: "skyblue" }}>{moreInfo}</p>
                            </Link>
                        }

                    </CookieConsent>}
                    {peDomain ? this.renderPromptAlertBox() : null}
                    {myDomain ? this.renderNotificationAlertBox() : null}
                    {(window.location.href.indexOf('/login') != -1 || window.location.href.indexOf('/twoStepLogin') != -1) ?
                        <Aux>
                            <Route path="/login" name="Login Page" component={Login} />
                            <Route path="/twoStepLogin" name="TwoStepLogin" component={TwoStepLogin} />
                            {/* {config.subDomain === "es2" && isOnlyBeemobi && <Footer isAdmin={this.props.user.isAdmin} changeLang={this.props.changeLang} currentLang={this.props.currentLang} />} */}
                        </Aux>

                        :
                        <Aux>

                            <div>
                                <Header changeLang={this.props.changeLang} currentLang={this.props.currentLang} isAdmin={this.props.user.isAdmin} pathName={this.props.location.pathname} onLoginClick={() => this.toggleMaxisLoginBox(true)} />

                                <Sidebar changeLang={this.props.changeLang} currentLang={this.props.currentLang} isAdmin={this.props.user.isAdmin} />
                            </div>
                            <div className={app_body_class}>
                                <Route path="/404" name="Page 404" component={Page404} />
                                <Route path="/500" name="Page 500" component={Page500} />
                                <Route path="/restricted" name="Access Denied" component={AccessDenied} />
                                {config.subDomain !== 'pk' && <Route path="/welcome" name="Welcome Page" component={Welcome} />}
                                <Route name="Home" component={Home} />
                            </div>
                            {window.location.hostname.includes('vplay') ? null : 
                            <Footer isAdmin={this.props.user.isAdmin} changeLang={this.props.changeLang} currentLang={this.props.currentLang} />
                            }
                            <Overlay isAdmin={this.props.user.isAdmin} />

                        </Aux>

                    }




                    <ActivityIndicator isLoading={this.props.loader.isLoading} />
                    {this.renderMaxisLoginBox()}
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        loader: state.ActivityIndicatorReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/containers/App.js